<template>
  <div
    :class="`alert_container mt-16 mt-md-n5 mx-5 mx-md-4 mr-4 mr-md-3 pt-4 pt-md-8 pb-4 pb-md-7 px-5 px-md-10 ${item.type}`"
  >
    <v-row class="d-flex ma-0">
      <v-col class="align-center">
        <p class="alert_title ma-0 mb-3">{{ item.title }}</p>
        <p class="alert_text ma-0">{{ item.text }}</p>
      </v-col>
      <v-col cols="3" md="1" class="d-flex align-center">
        <v-btn
          color="#8391AE"
          width="60"
          height="60"
          class="close_btn"
          outlined
          @click="$emit('update', false)"
        >
          <img src="../assets/plus-symbol.svg" alt="close" />
        </v-btn>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  name: "Alert",
  props: ["item"],
  data() {
    return {
      alert: null,
    };
  },
  created() {
    this.alert = this.item;
  },
};
</script>
<style scoped>
.alert_container {
  position: absolute;
  z-index: 12;
  top: 15px;
  left: 0;
  right: 0;
  box-shadow: 0px 4px 30px rgba(0, 0, 0, 0.07);
  border-radius: 20px;
}
.success_alert {
  background-color: #d4efdc;
  color: #1e4f2c;
}
.error_alert {
  background-color: #f9dbdb;
  color: #743d3d;
}
.warn_alert {
  background-color: #fcecb3;
  color: #7e6c2b;
}
.alert_title {
  font-weight: bold;
  font-size: 24px;
  line-height: 29px;
}
.alert_text {
  font-size: 18px;
  line-height: 22px;
}
.close_btn {
  min-width: 0 !important;
  border-radius: 50%;
}
</style>
